import React from 'react'
import '../../styles/mdx.scss'

export default function Flexitem2({ children }) {
  return (
    <div className="mdx">
        <div className="mdx__flexitem2">
            { children }
        </div>
    </div>
  )
}